export default "__VITE_ASSET__Dbu8DRdS__"